import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Koodi soodustus arvutatakse toote täishinnast ning see ei rakendu poes müüdavatele tehnikatoodetele ja jalgratastele tulenevalt tarnelepingutest. Vabandame!

  <span style="color:#85c1dc;">**FI:**</span>
  Alennuskoodi lasketaan normaalihinnasta. Alennus ei koske elektroniikkaa eikä polkupyöriä toimitussopimuksista johtuen. Pahoittelemme!

  <span style="color:#85c1dc;">**RU:**</span>
  Скидка по коду рассчитывается от обычной цены. Скидочный код не распространяется на технику и велосипеды из-за условий договора поставки. Приносим извинения!
*/
/* @__NO_SIDE_EFFECTS__ */
const m376 = msg(
  mf`Koodi soodustus arvutatakse toote täishinnast ning see ei rakendu poes müüdavatele tehnikatoodetele ja jalgratastele tulenevalt tarnelepingutest. Vabandame!`,
  mf`Alennuskoodi lasketaan normaalihinnasta. Alennus ei koske elektroniikkaa eikä polkupyöriä toimitussopimuksista johtuen. Pahoittelemme!`,
  mf`Скидка по коду рассчитывается от обычной цены. Скидочный код не распространяется на технику и велосипеды из-за условий договора поставки. Приносим извинения!`,
)

export { m376 as 'w.basket.summary.voucher_tooltip' }